import { Typography } from '@trellis/roots/typography'
import { DOCS_URL, SUPPORT_EMAIL } from '@trellis/shared'

export function SupportLinks() {
  return (
    <Typography variant="caption" color="muted" className="text-center">
      Need help?{' '}
      <a
        href={DOCS_URL}
        target="_blank"
        rel="noreferrer"
        className="text-foreground underline underline-offset-4"
      >
        Read the docs
      </a>{' '}
      or{' '}
      <a
        href={`mailto:${SUPPORT_EMAIL}`}
        className="text-foreground underline underline-offset-4"
      >
        email {SUPPORT_EMAIL}
      </a>
    </Typography>
  )
}
